





















































interface SelectOption {
    value: string;
    label: string;
}

import Vue from 'vue';

// Components
import Header from '../../components/layouts/Header.vue';
import MainLayout from '../../components/layouts/mainlayout/MainLayout.vue';
import Pagination from '../../components/miscellaneous/Pagination.vue';
import SchoolEventCard from './SchoolEventCard.vue';

// Services
import SchoolEventService, {
    SchoolEvent,
    EventType,
    EventPrivacy,
    SchoolEventUser,
} from '../../services/SchoolEventService';

export default Vue.extend({
    name: 'SchoolEvents',
    components: {
        Header,
        MainLayout,
        Pagination,
        SchoolEventCard,
    },
    data() {
        return {
            events: [] as SchoolEvent[],
            myEvents: [] as SchoolEventUser[],
            service: undefined as SchoolEventService | undefined,
            search: '',
            filters: {
                type: 'all' as 'all' | EventType | 'mine',
                search: '',
            },
        };
    },
    computed: {
        filteredEvents(): SchoolEvent[] {
            let events = this.events;
            if (this.filters.type === 'mine') {
                events = events.filter(event => this.isMyEvent(event));
            } else if (this.filters.type !== 'all') {
                events = events.filter(event => event.type === this.filters.type);
            }

            if (this.filters.search !== '') {
                events = events.filter(
                    event =>
                        event.title.toLowerCase().includes(this.filters.search.toLowerCase()) ||
                        event.description.toLowerCase().includes(this.filters.search.toLowerCase())
                );
            }
            return events;
        },
        filterOptions(): SelectOption[] {
            return [
                {
                    label: this.$t('schoolevents.filter.all').toString(),
                    value: 'all',
                },
                {
                    label: this.$t('schoolevents.filter.virtual').toString(),
                    value: 'virtual',
                },
                {
                    label: this.$t('schoolevents.filter.physical').toString(),
                    value: 'physical',
                },
                {
                    label: this.$t('schoolevents.filter.hybrid').toString(),
                    value: 'hybrid',
                },
                {
                    label: this.$t('schoolevents.filter.myEvents').toString(),
                    value: 'mine',
                },
            ];
        },
    },
    methods: {
        getEvents() {
            Promise.all([this.service!.getSchoolEvents(), this.service!.getMySchoolEvents()])
                .then(([events, myEvents]) => {
                    this.events = events;
                    this.myEvents = myEvents;
                })
                .catch(err => {
                    console.error(err);
                });
        },
        handleSearch() {
            this.filters.search = this.search;
        },
        isMyEvent(event: SchoolEvent) {
            return this.myEvents.some(myEvent => myEvent.schoolEventId === event.schoolEventId);
        },
        isRegisteredToEvent(event: SchoolEvent) {
            return this.myEvents.some(myEvent => {
                return myEvent.schoolEventId === event.schoolEventId && myEvent.registered;
            });
        },
        handleOpenEvent(event: SchoolEvent) {
            this.$router.push({
                name: 'schooleventpage',
                params: {
                    id: event.schoolEventId!,
                },
            });
        },
    },
    mounted() {
        this.service = new SchoolEventService();
        this.getEvents();
    },
});
